import React from "react";
import { useTranslation } from "react-i18next";
import { Typography, Button, Box } from "@mui/material";
import { AggregatedFundCommissionStatistics } from "@rentablo/api/apiv1";
import CashIcon from "@icons/myicons/cash-double.svg?react";
import CheckIcon from "@icons/check.svg?react";
import { toCurrency } from "@helpers";
import { MiniCard } from "@rentablo/components";

type Props = {
  fundCommissions: AggregatedFundCommissionStatistics;
  currency: string;
};

export const CashbackSuggestionCard = ({
  fundCommissions,
  currency,
}: Props) => {
  const { t } = useTranslation();

  const redirectToCashback = () => {
    window.location.href = `${
      import.meta.env.VITE_APP_V2_URL
    }/cashback-wizard-start`;
  };

  return (
    <MiniCard
      title={t("dashboardPage.cashbackSuggestionCard.title", {
        amount: toCurrency(
          fundCommissions.cashbackAdvantage?.cashbackAdvantage,
          currency
        ),
      })}
      variant="primary"
      caption={
        <Typography
          variant="overline"
          fontWeight={600}
          color="primary.main"
          textTransform="uppercase"
        >
          {t("dashboardPage.cashbackSuggestionCard.subtitle")}
        </Typography>
      }
    >
      <Box>
        <Box display="flex" gap={0.5} color="success.dark">
          <CheckIcon />
          <Typography variant="body3" mb={3}>
            {t("dashboardPage.cashbackSuggestionCard.discount")}
          </Typography>
        </Box>

        <Button
          startIcon={<CashIcon />}
          size="small"
          onClick={redirectToCashback}
          variant="outlined"
        >
          {t("dashboardPage.cashbackSuggestionCard.button")}
        </Button>
      </Box>
    </MiniCard>
  );
};
